/** @format */
import { useEffect, useRef, useState } from 'react';

import { getCsrfToken } from '@toucan/client/global/application';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
interface UseCsrfResponse {
    csrfToken: string;
    refreshCsrf: () => Promise<string>;
}

export function useCsrf(): UseCsrfResponse {
    const [csrfToken, setCsrfToken] = useState<string>('');
    const isCancelled = useRef(false);

    async function getAndSetToken() {
        try {
            const response = await getCsrfToken();

            if (!isCancelled.current) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
                const token = response?.data?.csrfToken ?? '';
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
                setCsrfToken(token);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
                return token;
            }

            return '';
        } catch {
            return '';
        }
    }

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Legacy code: do not use as an example.
        getAndSetToken();

        return () => {
            isCancelled.current = true;
        };
    }, []);

    return {
        csrfToken,
        refreshCsrf: getAndSetToken,
    };
}
